module.exports = new __parcel__URL__("JiraProjectDiscovery.556db745.svg").toString();